import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { concatMap, Observable } from 'rxjs';
import { TemplateService } from './template.service';
import { DocumentService } from './document.service';
import { IDocument } from '@interfaces/nebula';
import { LoggerService } from './logger.service';
import { SharedataService } from './sharedata.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateResolverService implements Resolve<IDocument> {
  private logger = inject(LoggerService);
  private documentService = inject(DocumentService);
  private templateService = inject(TemplateService);
  private data = inject(SharedataService);


  resolve(route: ActivatedRouteSnapshot): Observable<IDocument> {
    const templateId = route.paramMap.get('templateid');
    this.logger.debug('Lade Template mit ID: {@templateid}', { templateId });
    const isNavPinned = JSON.parse(localStorage.getItem('navigation-pinned')) as boolean;
    if (!isNavPinned) {
      this.data.isNavigationPaneHidden.set(true);
    }

    return this.templateService.getTemplate(templateId)
      .pipe(
        concatMap(template => this.documentService.createDocumentByTemplateId(template))
      );
  }
}
